import React from "react";
import "./Custom.css";
import PropTypes from "prop-types";

const SectionHeading = ({ heading }) => {
  const { headingOne, headingTwo, describe } = heading;
  SectionHeading.propTypes = {
    heading: PropTypes.object.isRequired, // Replace `object` with the correct type
  };
  return (
    <div className="pb-[3rem] !text-center">
      {/* <h3 className="text-secondary text-2xl font-semibold">{subHeading}</h3> */}
      <h2 className="font-bold lg:text-5xl md:text-3xl text-2xl my-2 title mb-[25px]   !leading-[140%] !text-center">
        {headingOne} <span className="text-pent">{headingTwo}</span>
      </h2>
      <p className="mx-auto  paragraph">{describe}</p>
    </div>
  );
};

export default SectionHeading;
